// Slice RTK per `state.grouped_trips_filters`.
// Pattern identico a cdiFiltersSlice — vedi quello per la doc del pattern.

import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const groupedTripsFiltersSlice = createSlice({
  name: 'grouped_trips_filters',
  initialState,
  reducers: {
    set: (_state, action) => action.payload ?? {},
    update: (state, action) => ({ ...state, ...action.payload }),
    clear: () => initialState,
  },
});

export const {
  set: setGroupedTripsFilters,
  update: updateGroupedTripsFilters,
  clear: clearGroupedTripsFilters,
} = groupedTripsFiltersSlice.actions;

export default groupedTripsFiltersSlice.reducer;
